<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout justify-space-between>
        <v-flex xs3 sm3 md3 d-flex>
          <div>
            <note-manage-modal ref="noteModal" :currentNote="currentNote" :patient-id="patient_id" @closed="currentNote = null"/>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
        :items="notes.items"
        :disable-initial-sort="true"
        :headers="headers"
        :pagination.sync="pagination"
        :total-items="total"
        :loading="isLoading"
        :rows-per-page-items="[10,25,50,100]"
        :no-data-text="trans('app.search.no_data')"
    >

      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

      <template slot="items" slot-scope="props">
        <tr>
          <td>
            {{ props.item.note }}
          </td>
          <td class="text-xs-center">
            {{ props.item.created_at | format_date() }}
          </td>
          <td class="justify-end layout px-0 pr-4">
            <v-layout align-center justify-end>
              <icon-button
                  :permission="hasPermission('patient_notes_edit')"
                  icon="edit"
                  color="success"
                  cls="mr-0 ml-0"
                  :tooltip="{top: true, bottom: false, attach: false}"
                  :iconOptions="{small: true}"
                  @click="editNote(props.item)"
              >{{ 'app.show_and_edit' | trans }}
              </icon-button>
              <icon-button
                  :permission="hasPermission('patient_notes_delete')"
                  icon="delete"
                  color="red"
                  cls="mr-0 ml-0"
                  :tooltip="{top: true, bottom: false, attach: false}"
                  :iconOptions="{small: true}"
                  @click="deleteNote(props.item)"
              >
                {{ 'app.delete' | trans }}
              </icon-button>
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {trans} from "../../app";
import goTo from "vuetify/lib/components/Vuetify/goTo";
import {mapActions, mapGetters} from "vuex";
import NoteService from "../../services/NoteService";

export default {
  props: {
    patient_id: {
      type: Number,
    }
  },
  data: function () {
    return {
      total: 0,
      isLoading: true,
      pagination: {
        rowsPerPage: 50,
        sortBy: 'created_at',
        descending: true,
      },
      headers: [
        {
          text: trans('app.content'), align: 'left', value: 'note', sortable: true,
        },
        {
          text: trans('app.date'), align: 'center', value: 'created_at', sortable: true,
        },
        {
          text: '', align: 'center', sortable: false,
        },
      ],
      currentNote: null,
    };
  },
  methods: {
    ...mapActions(['fetchNotes']),
    async fetchData() {
      this.isLoading = true;
      const {sortBy, descending, page, rowsPerPage} = this.pagination;

      const query = {
        page: page,
        perPage: rowsPerPage,
        orderBy: sortBy,
        dir: descending ? 'desc' : 'asc',
      };

      await this.fetchNotes({patientId: this.patient_id, query});

      this.total = this.notes.total;
      this.pages = this.notes.last_page;
      this.isLoading = false;
    },
    async deleteNote(note) {
      const confirm = await this.$confirm(trans('app.notes_in_patient_panel.confirm_note_removal'), {
        title: trans('app.notes_in_patient_panel.remove_note')
      });

      if (confirm) {
        goTo(0, {
          duration: 1000
        });
        this.isLoading = true;
        await new NoteService().deleteNote(this.patient_id, note.id);
        await this.fetchData();
        this.$toast(trans('app.actions.removed', {name: trans('app.note_accusative')}));
        this.isLoading = false;
      }
    },
    editNote(note) {
      this.currentNote = note;
      this.$refs.noteModal.open();
    },
    resetSearch() {
      this.pagination.sortBy = 'created_at';
      this.pagination.descending = true;
      this.pagination.rowsPerPage = 50;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['notes', 'hasPermission']),
  },
}
</script>
